function hashString (str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0 // força 32 bits
  }
  return Math.abs(hash)
}

export function generateColorFromId (id: string, totalSteps = 36) {
  const hash = hashString(id)

  const stepSize = 360 / totalSteps
  const hue = (Math.floor(hash % totalSteps) * stepSize) % 360

  const saturation = 40 + (hash % 11)
  const lightness = 50 + (Math.floor(hash / 10) % 11)

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}
